<template>
    <div id="app">
        <StaffHeader v-if="isStaffWorkspace" :site-config="siteConfig" :logo-src="logoSrc" />
        <headerPage v-else-if="!isStaffLogin && !isCheckinRoute" :site-config="siteConfig" :logo-src="logoSrc"></headerPage>
        <router-view />
        <StaffFooter v-if="isStaffWorkspace" :site-config="siteConfig" :logo-src="logoSrc" />
        <footerPage v-else-if="!isStaffLogin && !isCheckinRoute" :site-config="siteConfig" :logo-src="logoSrc"></footerPage>
        <RealnameDialog v-if="!isStaffRoute && !isCheckinRoute" />
    </div>
</template>

<script>
import headerPage from '@/components/headerPage.vue'
import footerPage from '@/components/footerPage.vue'
import RealnameDialog from '@/components/RealnameDialog.vue'
import StaffHeader from '@/components/StaffHeader.vue'
import StaffFooter from '@/components/StaffFooter.vue'
import { mediaUrl } from '@/utils/media'

export default {
    name: 'App',
    components: {
        headerPage,
        footerPage,
        RealnameDialog,
        StaffHeader,
        StaffFooter,
    },
    data() { return { siteConfig: null } },
    computed: {
        isStaffLogin() { return this.$route.path === '/staff/login' },
        isStaffRoute() { return this.$route.path.indexOf('/staff/') === 0 },
        isCheckinRoute() { return this.$route.path.indexOf('/checkin/') === 0 },
        isStaffWorkspace() { return this.isStaffRoute && !this.isStaffLogin },
        logoSrc() {
            const url = this.siteConfig && this.siteConfig.logoUrl
            return url === '/figma/logo.svg' ? url : mediaUrl(url)
        },
    },
    created() { this.loadSiteConfig() },
    methods: {
        async loadSiteConfig() {
            try {
                const response = await this.$api('/api/website/site-config', 'get')
                this.siteConfig = response.data || null
            } catch (error) { this.siteConfig = null }
        },
    },
}
</script>

<style lang="less">
@import '~@/assets/js/swiper-bundle.min.css';
.m_width { max-width: 1400px; width: calc(100% - 48px); margin: 0 auto; }
body{margin:0;background:#f5f8fd;color:#1f2d4d;font-family:"PingFang SC","Microsoft YaHei",sans-serif}button,input,textarea{font:inherit}a{text-decoration:none;color:inherit}a:hover{text-decoration:none}.page{min-height:calc(100vh - 300px)}
.page-shell{max-width:1440px;width:calc(100% - 48px);margin:0 auto}.page-hero{padding:52px 0 30px;background:linear-gradient(135deg,#eaf2ff,#f8fbff)}.page-hero h1{font-size:34px;margin:0 0 12px}.page-hero p{color:#71809c;margin:0}.surface{background:white;border:1px solid #e9eef8;border-radius:16px;box-shadow:0 10px 34px rgba(30,66,130,.06)}
.section{padding:46px 0}.section-title{display:flex;align-items:end;justify-content:space-between;margin-bottom:22px}.section-title h2{font-size:26px;margin:0}.section-title p{color:#8190aa;margin:8px 0 0}.empty-state{text-align:center;color:#8b99b1;padding:72px 20px}.empty-state i{font-size:44px;color:#c3cee0;display:block;margin-bottom:16px}.primary-button{border:0;border-radius:9px;background:#2867e8;color:white;padding:12px 24px;cursor:pointer}.ghost-button{border:1px solid #ccd8eb;border-radius:9px;background:white;color:#385273;padding:11px 22px;cursor:pointer}.status-tag{display:inline-block;padding:4px 10px;border-radius:14px;background:#edf4ff;color:#2867e8;font-size:12px}
@media(max-width:768px){.m_width,.page-shell{width:calc(100% - 28px)}.page-hero{padding:34px 0 22px}.page-hero h1{font-size:26px}.section{padding:30px 0}.section-title h2{font-size:22px}}

.btnHover {
    cursor: pointer;

    &:hover {
        opacity: 0.85;
    }
}

.btnHover2 {
    vertical-align: bottom;
    cursor: pointer;
}

.btnHover2:not(:disabled):hover {
    opacity: 1;
    position: relative;
    overflow: hidden;

    &::before {
        animation: ani_ripple 0.75s;
        z-index: 1;
        content: '';
        position: absolute;
        display: block;
        transition: all 0.6s;
        width: 100%;
        height: 0;
        border-radius: 50%;
        left: 50%;
        top: 50%;
        padding-top: 100%;
        transform: translateX(-50%) translateY(-50%);
    }
}

@keyframes ani_ripple {
    0% {
        background: rgba(0, 0, 0, 0.25);
        transform: translateX(-50%) translateY(-50%) scale(0);
    }

    to {
        background: transparent;
        transform: translateX(-50%) translateY(-50%) scale(1);
    }
}
</style>
